import React, { useMemo } from 'react';
import Select from 'react-select';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { orange, red } from '@material-ui/core/colors';
import { getStats } from '../../features/getstats';
import { useNavigate } from 'react-router-dom';
import { selectGenerator } from '../../features/selectgenerator';
import useStyles from './startStyle';
import heroes from '../../heroesNames.json';

function Start({ setData, setLoading, isDark, closeMenu, startDeps }) {
	const { radiantPick, direPick, radiantName, direName, tournamentID, settournamentID, setRadiantName, setRadiant, setDireName, setDire } =
		startDeps;
	const classes = useStyles();
	const navigate = useNavigate();

	async function handleClick() {
		setLoading(true);
		closeMenu(false);

		try {
			let result = await getStats(radiantPick, direPick, radiantName, direName, tournamentID);
			if (result?.isNeedAuth) {
				navigate('/login');
			}
			setData(result);
		} catch (e) {
			setData({ status: 'start' });
			console.error(e);
		}
		setLoading(false);
	}

	const clearHandler = () => {
		setRadiant({});
		setDire({});
		setRadiantName('');
		setDireName('');
		settournamentID('');
	};

	const customStyles = {
		option: (provided) => ({
			...provided,
			color: 'black',
			select: {
				height: '5.5rem',
			},
		}),
	};

	const options = useMemo(() => selectGenerator(heroes), [heroes]);

	return (
		<form noValidate autoComplete="off" className={classes.formStyle}>
			<Button
				style={{
					background: '#717371',
					color: 'white',
				}}
				size="small"
				onClick={() => closeMenu(false)}
			>
				Закрыть
			</Button>
			<div className="hawkInput">
				<Typography variant="h6">Tournament ID</Typography>
				<TextField
					id="stratz-data"
					variant="outlined"
					fullWidth={true}
					value={tournamentID}
					onChange={(e) => settournamentID(e.target.value)}
				/>
			</div>
			<div className={classes.pick}>
				<div className={classes.pickBody}>
					<Typography variant="h6">Radiant Team</Typography>
					<TextField
						variant="outlined"
						fullWidth={true}
						data-test="radiant-name"
						value={radiantName}
						className={classes.teamName}
						onChange={(e) => setRadiantName(e.target.value)}
					/>
					<Typography variant="h6" gutterBottom>
						Radiant Pick
					</Typography>
					{['Carry', 'Mid', 'Offlane', 'Support (4)', 'Support (5)'].map((item) => {
						return (
							<React.Fragment key={item + 'radiant'}>
								<Typography className={classes.selectHero} variant="body">
									{item}
								</Typography>
								<Select
									className={classes.select}
									styles={customStyles}
									options={options}
									onChange={(e) => {
										setRadiant({ ...radiantPick, [item]: e.value });
									}}
									value={radiantPick[item] ? { value: radiantPick[item], label: radiantPick[item] } : null}
								/>
							</React.Fragment>
						);
					})}
				</div>
				<div className={classes.pickBody}>
					<Typography variant="h6">Dire Team</Typography>
					<TextField
						variant="outlined"
						fullWidth={true}
						value={direName}
						data-test="dire-name"
						className={classes.teamName}
						onChange={(e) => setDireName(e.target.value)}
					/>
					<Typography variant="h6" gutterBottom>
						Dire Pick
					</Typography>
					{['Carry', 'Mid', 'Offlane', 'Support (4)', 'Support (5)'].map((item) => {
						return (
							<React.Fragment key={item + 'dire'}>
								<Typography className={classes.selectHero} variant="body">
									{item}
								</Typography>
								<Select
									className={classes.select}
									styles={customStyles}
									options={options}
									onChange={(e) => {
										setDire({ ...direPick, [item]: e.value });
									}}
									value={direPick[item] ? { value: direPick[item], label: direPick[item] } : null}
								/>
							</React.Fragment>
						);
					})}
				</div>
			</div>
			<Button
				className={classes.buttonStart}
				size="medium"
				style={{
					background: isDark ? orange[500] : 'rgba(0,0,0,1)',
					color: 'white',
				}}
				onClick={() => {
					handleClick();
				}}
			>
				Проанализировать
			</Button>
			<Button
				className={classes.buttonStart}
				size="medium"
				style={{
					background: red[500],
					color: 'white',
				}}
				onClick={clearHandler}
			>
				Очистить форму
			</Button>
		</form>
	);
}

export default Start;
